import { render } from "./GridIntretinuti.vue?vue&type=template&id=9f0c7654&ts=true"
import script from "./GridIntretinuti.vue?vue&type=script&lang=ts"
export * from "./GridIntretinuti.vue?vue&type=script&lang=ts"

import "./GridIntretinuti.vue?vue&type=style&index=0&id=9f0c7654&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__